<section *ngIf="authService.getUsuario">
  <app-mainavbar [idRol]="authService.getUsuario.fk_rol" [idNivel]="authService.getUsuario.fk_nivel"></app-mainavbar>

  <div class="flex flex-wrap justify-content-evenly">

    <p-card [header]="'Productos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="mensaje('productos')">
        <a [routerLink]="['./productos']">{{totalProductos}}</a>
      </p>
    </p-card>

    <p-card [header]="'Casos Clínicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="mensaje('casos clínicos')">
        <a [routerLink]="['./casosclinicos']">{{totalCasosClinicos}}</a>
      </p>
    </p-card>

    <p-card [header]="'Puntos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="mensaje('puntos')">
        {{totalPuntos}}
      </p>
    </p-card>

    <p-card [header]="'Saldo'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="mensaje('saldos')">
        <a [routerLink]="['./saldo']"> {{saldo}} </a>
      </p>
    </p-card>

  </div>

  <router-outlet></router-outlet>
</section>